<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{title! | translate}}</h5>
        </div>
        <div class="modal-body">
            <div class="form-floating form-item">
                <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
                    class="form-control filter-field"
                    id="floatingInput" (ngModelChange)="onFilterChange()" (click)="openDropdown()" placeholder=" " />
                <label class="input-label" for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

                <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
                    <div click-stop-propagation class="agent-name" (click)="selectFieldAgent($event, u.id!)"
                        *ngFor="let u of mobileUsers">
                        {{ u.fullName }}
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn cancel-button" #closeModal data-bs-dismiss="modal" aria-label="Close">
                <span>{{'COMMON.CANCEL' | translate }}</span>
            </button>
            <button type="button" class="btn btn-primary" (click)="assignTask()">
                <span>{{submitText! | translate }}</span>
            </button>
        </div>
    </div>
</div>